export default __webpack_public_path__ + "d41d8cd98f00b204e9800998ecf8427e.svg";